import axios from "axios";
import { environment } from "../../environments/environment";
import { LoginPayload, LoginResponse } from "../../services/Login/login.types";

const API_BASE_NAME = `${environment.apiBaseUrl}`;

export const loginApi = async (
  payload: LoginPayload
): Promise<LoginResponse> => {
  try {
    const res = await axios.post<LoginResponse>(
      `${API_BASE_NAME}/admin/login`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    localStorage.setItem("token", res.data.token);
    localStorage.setItem("isAuthenticated", "true");
    // localStorage.setItem("user", res.data);

    return res.data;
  } catch (error: any) {
    console.error(
      "❌ Login failed:",
      error.response?.data || error.message
    );
    throw error;
  }
};
